module.exports = __webpack_public_path__ + "img/home-light.efb39a15.svg";